import { render, staticRenderFns } from "./EditSent.vue?vue&type=template&id=c5a2f40e"
import script from "./EditSent.vue?vue&type=script&lang=js"
export * from "./EditSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports